var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main-content orderImport" },
    [
      _vm.editableRecord
        ? _c("updateBlackList", {
            attrs: {
              drug: _vm.editableRecord,
              type: "autolist",
              closeModal: _vm.closeModal,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.countries
        ? _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-body" }, [
              _c("div", { staticClass: "flex" }, [
                _c("div", { staticClass: "form-group m-r-10 mb-0" }, [
                  _c("label", { attrs: { for: "" } }, [
                    _vm._v("Выберите страну"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.selectedCountry,
                          expression: "selectedCountry",
                        },
                      ],
                      staticClass: "form-control",
                      on: {
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.selectedCountry = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                      },
                    },
                    _vm._l(_vm.countries, function (name, index) {
                      return _c("option", { domProps: { value: index } }, [
                        _vm._v(_vm._s(name)),
                      ])
                    }),
                    0
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "flex" },
                  [
                    _c(
                      "vue-ladda",
                      {
                        attrs: {
                          "button-class": "btn btn-info align-self-end",
                          "data-style": "zoom-in",
                          loading: _vm.btnLoading,
                        },
                        on: { click: _vm.getDrugs },
                      },
                      [_vm._v("Просчитать список\n          ")]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card-body" }, [
          _c(
            "div",
            { staticClass: "text-center" },
            [
              _c("pulse-loader", {
                attrs: { loading: _vm.loading, color: _vm.color },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.drugs
            ? _c("div", [
                _c("div", { staticClass: "text-right" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-success",
                      on: { click: _vm.printTable },
                    },
                    [_vm._v("Печать")]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { attrs: { id: "printTable" } }, [
                  _c(
                    "table",
                    {
                      staticClass:
                        "table table-sm table-hover default_table table-striped mt-0",
                    },
                    [
                      _c("thead", [
                        _c("tr", [
                          _c("th", { attrs: { width: "50" } }),
                          _vm._v(" "),
                          _c("th", { attrs: { width: "50" } }),
                          _vm._v(" "),
                          _c("th", [_vm._v("Препарат")]),
                          _vm._v(" "),
                          _c(
                            "th",
                            { attrs: { width: "150" } },
                            [
                              _vm._v(
                                "\n                Общий Запрос\n                "
                              ),
                              _vm.statSettings
                                ? _c(
                                    "v-popover",
                                    {
                                      staticClass: "display-inline",
                                      attrs: {
                                        popoverClass: "work_shift_popover",
                                        popoverInnerClass: "popover_content",
                                        trigger: "hover",
                                        "auto-hide": true,
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "popover_icon" },
                                        [
                                          _c("i", {
                                            staticClass: "icon-fa icon-fa-info",
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("template", { slot: "popover" }, [
                                        _c("p", { staticClass: "mb-1" }, [
                                          _vm._v(
                                            "Статистика за: " +
                                              _vm._s(
                                                _vm.statSettings.statistic_days
                                              ) +
                                              " дней"
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("p", { staticClass: "mb-1" }, [
                                          _vm._v(
                                            "Запас на: " +
                                              _vm._s(
                                                _vm.statSettings.storage_days
                                              ) +
                                              " дней"
                                          ),
                                        ]),
                                      ]),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("th", {
                            staticClass: "hide_print",
                            attrs: { width: "50" },
                          }),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        _vm._l(_vm.activeDrugs, function (drug, index) {
                          return _c(
                            "tr",
                            {
                              class:
                                _vm.selectedCountry != drug.income_country_id
                                  ? "bg-danger"
                                  : "",
                            },
                            [
                              _c("td", [_vm._v(_vm._s(index + 1))]),
                              _vm._v(" "),
                              _c("td", [
                                drug.cool
                                  ? _c("span", {
                                      staticClass: "icon icon-snowflake",
                                    })
                                  : _vm._e(),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(drug.title) +
                                    " (" +
                                    _vm._s(drug.id) +
                                    ")\n                "
                                ),
                                drug.pack_set && drug.pack_set != 1
                                  ? _c("p", { staticClass: "pack_comment" }, [
                                      _vm._v("Препарат комплектный: "),
                                      _c(
                                        "span",
                                        { staticClass: "badge badge-info" },
                                        [_vm._v("1 комплект")]
                                      ),
                                      _vm._v(" - "),
                                      _c("strong", [
                                        _vm._v(_vm._s(drug.pack_set)),
                                      ]),
                                      _vm._v("\n                  (зав.уп.)"),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                drug.pack_comment
                                  ? _c("p", { staticClass: "pack_comment" }, [
                                      _vm._v(_vm._s(drug.pack_comment)),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                drug.pack_box_comment
                                  ? _c(
                                      "p",
                                      { staticClass: "pack_box_comment" },
                                      [_vm._v(_vm._s(drug.pack_box_comment))]
                                    )
                                  : _vm._e(),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.getTotalAmount(drug.id)) +
                                    "\n              "
                                ),
                              ]),
                              _c(
                                "td",
                                [
                                  _c(
                                    "dropdown-menu",
                                    {
                                      attrs: {
                                        interactive: true,
                                        closeOnClickOutside: true,
                                      },
                                      model: {
                                        value: drug.showDropDown,
                                        callback: function ($$v) {
                                          _vm.$set(drug, "showDropDown", $$v)
                                        },
                                        expression: "drug.showDropDown",
                                      },
                                    },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "btn btn-default dropdown-toggle1",
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "icon-fa icon-fa-ellipsis-v",
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          attrs: { slot: "dropdown" },
                                          slot: "dropdown",
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "dropdown-item pointer",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.editRecord(drug)
                                                },
                                              },
                                            },
                                            [_vm._v("Игнорирование")]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                    ]
                  ),
                ]),
              ])
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _vm.ignoredDrugs && Object.keys(_vm.ignoredDrugs).length
        ? _c("div", { staticClass: "card" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "card-body" }, [
              _c(
                "table",
                { staticClass: "table table-sm table-hover table-striped" },
                [
                  _vm._m(1),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(_vm.ignoredDrugs, function (drug, drugId, index) {
                      return _c("tr", [
                        _c("td", [_vm._v(_vm._s(index + 1))]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n            " +
                              _vm._s(drug.title) +
                              " (" +
                              _vm._s(drugId) +
                              ")\n            "
                          ),
                          drug.pack_comment
                            ? _c("p", { staticClass: "pack_comment" }, [
                                _vm._v(_vm._s(drug.pack_comment)),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          drug.pack_box_comment
                            ? _c("p", { staticClass: "pack_box_comment" }, [
                                _vm._v(_vm._s(drug.pack_box_comment)),
                              ])
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.getTotalAmount(drugId)) +
                              "\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "hide_print" },
                          _vm._l(drug.comments, function (comment) {
                            return _c("div", [
                              _c("p", { staticClass: "mb-1" }, [
                                _vm._v(_vm._s(comment.comment)),
                              ]),
                              _vm._v(" "),
                              _c("small", [
                                _vm._v(
                                  _vm._s(comment.user_name) +
                                    " (" +
                                    _vm._s(comment.date) +
                                    ")"
                                ),
                              ]),
                            ])
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.moment(drug.actual_date, "DD.MM.YYYY")
                              ) +
                              "\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          [
                            _c(
                              "dropdown-menu",
                              {
                                attrs: {
                                  interactive: true,
                                  closeOnClickOutside: true,
                                },
                                model: {
                                  value: drug.showDropDown,
                                  callback: function ($$v) {
                                    _vm.$set(drug, "showDropDown", $$v)
                                  },
                                  expression: "drug.showDropDown",
                                },
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-default dropdown-toggle1",
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "icon-fa icon-fa-ellipsis-v",
                                    }),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    attrs: { slot: "dropdown" },
                                    slot: "dropdown",
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "dropdown-item pointer",
                                        on: {
                                          click: function ($event) {
                                            return _vm.deleteIgnore(drug.id)
                                          },
                                        },
                                      },
                                      [_vm._v("Удалить с игнорирования")]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ])
                    }),
                    0
                  ),
                ]
              ),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h6", [_vm._v("Препараты, которые игнорированны для просчета")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Препарат")]),
        _vm._v(" "),
        _c("th", [_vm._v("Запрос")]),
        _vm._v(" "),
        _c("th", { staticClass: "hide_print" }, [_vm._v("Комментарий")]),
        _vm._v(" "),
        _c("th", [_vm._v("Актуально до")]),
        _vm._v(" "),
        _c("th"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }